import { render, staticRenderFns } from "./Import_resume.vue?vue&type=template&id=7f2e88cc&scoped=true&"
import script from "./Import_resume.vue?vue&type=script&lang=js&"
export * from "./Import_resume.vue?vue&type=script&lang=js&"
import style0 from "./Import_resume.vue?vue&type=style&index=0&id=7f2e88cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e88cc",
  null
  
)

export default component.exports